import React from "react";
import {
  userImg,
  semiCircle,
  circle,
  instagram,
  github,
  linkedin,
  youtube,
  medal,
  heart,
  star,
  coding,
  comet,
} from "../../assets";
import SocialIcon from "../SocialIcon/SocialIcon";
import { motion } from "framer-motion";
import styles from "./Header.module.css";

const Header = () => {
  return (
    <header id="home" className={styles.container}>
      <motion.div
        className={styles.left}
        initial={{
          x: -850,
        }}
        animate={{
          x: 2,
        }}
        transition={{
          delay: 0.6,
          type: "spring",
          duration: 3,
        }}
      >
        <div className={styles.left__title}>
          <h1>Hi I'm Anton</h1>
          <h1>Francis Jeejo</h1>
        </div>
        <img src={circle} alt="" />
        <p>
          I'm a tech enthusiast who always looks into new tech stacks. A single
          word to represent me is adaptability. Loves to learn new technology to
          work on a project.
        </p>
        <button>
          <a href="#contact">Hire Me</a>
        </button>
        <div className={styles.social__container}>
          <SocialIcon
            image={instagram}
            url="https://www.instagram.com/antonfrancisjeejo"
          />
          <SocialIcon
            image={github}
            url="https://github.com/antonfrancisjeejo/"
          />
          <SocialIcon
            image={linkedin}
            url="https://www.instagram.com/antonfrancisjeejo"
          />
          <SocialIcon
            image={youtube}
            url="https://www.youtube.com/c/AntonFrancisJeejo13"
          />
        </div>
      </motion.div>
      <motion.div
        className={styles.right}
        initial={{
          x: 850,
        }}
        animate={{
          x: 2,
        }}
        transition={{
          delay: 0.6,
          type: "spring",
          duration: 3,
        }}
      >
        <div className={styles.right__image}>
          <img src={semiCircle} alt="" />
          <img src={userImg} alt="" />
        </div>
        <div className={styles.seller__box}>
          <img src={medal} alt="" />
          <h3>Level 2 Seller</h3>
        </div>
        <div className={styles.projects__box}>
          <div>
            <img src={heart} alt="" />
            <h3>Projects</h3>
          </div>
          <h2>300+ Done</h2>
        </div>
        <div className={styles.active__contributor}>
          <img src={star} alt="" />
          <h3>Active Github Contributor</h3>
        </div>
        <img src={coding} alt="" className={styles.coding__img} />
        <img src={comet} alt="" className={styles.comet__img} />
      </motion.div>
    </header>
  );
};

export default Header;
